import HeaderTitle from "@/Components/HeaderTitle";
import { useModal } from "@/hooks/utilsHooks";
import { Button, Modal, Skeleton } from "antd";
import { lazy, Suspense, useEffect, useState } from "react";
import { CiSaveDown1 } from "react-icons/ci";
import { IoMdAdd } from "react-icons/io";
import { IoBusiness } from "react-icons/io5";
import { useLocation } from "react-router-dom";
import { COMPANY_DATA_CONFIG, CompanyContainData } from "./utils/constants";

const DataTable = lazy(() => import("./Components/DataTable"));
const CompanyForm = lazy(() => import("./Components/Form/CompanyForm"));

export default function CompanyPage() {
  // state para manejar la muestra de audits y companies
  const [dataType, setData] = useState<CompanyContainData>(
    COMPANY_DATA_CONFIG.audits.typeData,
  );
  const { isOpen, open, close } = useModal();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === COMPANY_DATA_CONFIG.audits.path) {
      setData(COMPANY_DATA_CONFIG.audits.typeData);
    } else if (location.pathname === COMPANY_DATA_CONFIG.diagnosis.path) {
      setData(COMPANY_DATA_CONFIG.diagnosis.typeData);
    } else if (location.pathname === COMPANY_DATA_CONFIG.companies.path) {
      setData(COMPANY_DATA_CONFIG.companies.typeData);
    }
  }, [location.pathname]);
  // const authUser = useAppSelector((state) => state.auth.authUser);
  // const isOnlyConsultor = isOnlyConsultorGroup(
  //   authUser?.user.groups_detail ?? []
  // );
  return (
    <div className="flex flex-col">
      <div className="w-full flex flex-col md:flex-row items-center justify-between md:p-8">
        <HeaderTitle
          icon={<IoBusiness />}
          title="Gestión de las empresas"
          subTitle="Añade, actualiza, elimina y gestiona toda la información de las
          empresas"
        />
        {/* {!isOnlyConsultor && (
        )} */}
        <Button
          className="mt-8 mb-4 md:mt-0 md:mb-0"
          type="primary"
          icon={<IoMdAdd />}
          onClick={open}
        >
          Agregar Empresa
        </Button>
      </div>
      <Suspense fallback={<Skeleton />}>
        <DataTable dataType={dataType} />
      </Suspense>

      <Modal
        title={
          <span className="flex items-center justify-start">
            {" "}
            <CiSaveDown1 className="mr-2" />
            Agregar Empresa
          </span>
        }
        centered
        destroyOnClose
        open={isOpen}
        onOk={close}
        onCancel={close}
        width={1000}
        footer={null}
      >
        {isOpen && (
          <Suspense fallback={<Skeleton active />}>
            <CompanyForm onSuccess={close} />
          </Suspense>
        )}
      </Modal>
    </div>
  );
}
